// @flow

import Observer from 'react-intersection-observer';
import React, { Component, type ComponentType } from 'react';

/**
 * Decorates a component with a `componentDidAppear` lifecycle method
 */
const withDidAppear = (WrappedComponent: ComponentType<*>, once: boolean = false) => (
  class WithDidAppear extends Component<*> {
    child: any;

    isCalled: boolean;

    onChange = (inView: boolean) => {
      if (!inView) {
        return;
      }

      if (once && this.isCalled) {
        return;
      }

      this.child.componentDidAppear();
      this.isCalled = true;
    }

    render() {
      return (
        <Observer onChange={this.onChange}>
          <WrappedComponent {...this.props} ref={node => { this.child = node }} />
        </Observer>
      );
    }
  }
);

export default withDidAppear;
